import Button, { ButtonProps } from "@mui/material/Button";
import React from "react";

export type CommandButtonProps = Omit<ButtonProps, "size">;

export const CommandButton: React.FC<CommandButtonProps> = (props: CommandButtonProps) => {
  return <Button {...props} size="medium" />;
};
